import createSpinner from "../../../Shared/Functions/createSpinner";
import allSupportedProducts from '../../../Shared/GlobalVariables/ProductLookUp';
import { customAutoCompleteFilterEqualToOnly, customAutoCompleteFilter, customDatePickerFilter } from "../../../Shared/GlobalVariables/filterVariables";

export default /*@ngInject*/ function ($scope, $uibModalInstance, helperService, $http, lastClickedDataItemRecord) {

    const vm = this;

    vm.lastClickedDataItemRecord = lastClickedDataItemRecord;

    vm.linkCustomTicket = linkCustomTicket;
    vm.unLinkRecord = unLinkRecord;
    vm.dismiss = dismiss;

    activate();

    function activate() {
        let isCustomProduct = false;

        if (!vm.lastClickedDataItemRecord.auditLogTicket) {
            if (!allSupportedProducts.some(p => p.Type === vm.lastClickedDataItemRecord.ProductType)) {
                isCustomProduct = true;
            }

            if (vm.lastClickedDataItemRecord.ProductType === 'NS' || vm.lastClickedDataItemRecord.ProductType === 'ORFC' || vm.lastClickedDataItemRecord.ProductType === 'SF') {
                vm.AtHeaderId = vm.lastClickedDataItemRecord.Id;
            } else if (vm.lastClickedDataItemRecord.ProductType === 'GP' || vm.lastClickedDataItemRecord.ProductType === 'AX' || vm.lastClickedDataItemRecord.ProductType === 'NAV' || vm.lastClickedDataItemRecord.ProductType === 'SL' || vm.lastClickedDataItemRecord.ProductType === 'AX5' || isCustomProduct) {
                vm.AtHeaderId = vm.lastClickedDataItemRecord.TableLogID;
            } else if (vm.lastClickedDataItemRecord.ProductType === 'SAP') {
                vm.AtHeaderId = vm.lastClickedDataItemRecord.ChangeNumber;
            } else if (vm.lastClickedDataItemRecord.ProductType === 'D365Bc') {
                vm.AtHeaderId = vm.lastClickedDataItemRecord.entryNo;
            } else {
                vm.AtHeaderId = vm.lastClickedDataItemRecord.RecId;
            }
        }

        const statusTemplate = "<span class='review-status-capitalized'>{{dataItem.Status}}</span>";

        const columnsFromVM = [
            { field: "Status", title: "Status", template: statusTemplate, filterable: false },
            { field: "Id", title: "Id", filterable: customAutoCompleteFilterEqualToOnly },
            { field: "Subject", title: "Subject", filterable: customAutoCompleteFilter },
            { field: "Description", title: "Description", template: "{{ dataItem.Description }}", filterable: customAutoCompleteFilter }, // use template to handle possible issues with characters in description field
            { field: "CreatedDate", title: "Date Created", template: "{{ dataItem.CreatedDate | date:'short'}}", filterable: customDatePickerFilter },
            { title: ' ', template: "<span ng-disabled='ctmvm.actionInProgress || !ctmvm.customTicketId' class='btn btn-sm btn-secondary fixed-btn-width' ng-click='ctmvm.linkCustomTicket(dataItem)'>Link</span>", width: 90 }
        ];

        $scope.$evalAsync(function () {
            vm.gridOptions = helperService.setMainGridOptions(columnsFromVM, 400);
            vm.gridOptions.selectable = false;
            vm.gridOptions.pageable = false;
            vm.gridOptions.filterable = {
                mode: 'row',
                operators: {
                    string: {
                        contains: "Contains"
                    }
                }
            };
        });
    }

    async function linkCustomTicket () {
        vm.actionInProgress = new createSpinner();

        const productType = vm.lastClickedDataItemRecord.ProductType;
 
        let postData = {
            "TicketId": vm.customTicketId,
            "Provider": 'Custom'
        }

        if (vm.lastClickedDataItemRecord.auditLogTicket) {
            postData.AuditId = vm.lastClickedDataItemRecord.AuditId;
            postData.UserId = vm.lastClickedDataItemRecord.UserId;
            postData.ObjectName = vm.lastClickedDataItemRecord.ObjectName;
        } else {
            postData.AtHeaderIds = [];
            postData.AtHeaderIds.push(vm.AtHeaderId);
            postData.ProductId = vm.lastClickedDataItemRecord.ProductId;
            postData.ProductType = productType;
        }

        try {
            if (vm.lastClickedDataItemRecord.auditLogTicket) {
                await $http.post(apiUrl + 'api/core/auditlogs/associateticket', postData);
            } else {
                await $http.post(apiUrl + 'api/audittrail/tickets', postData);

                if (productType === 'OR' || productType === 'AX7' || productType === 'SAP') {
                    await buildHeaderPost(productType);
                }
            }

            await helperService.successfulSaveButton(vm.actionInProgress);
            $uibModalInstance.close();
        } catch (response) {
            helperService.showErrorMessage(response.data);
            vm.actionInProgress.loadingValue = false;
        }
    }

    async function buildHeaderPost(productType) {
        let headerPostData = { "Tickets": [] };
        let headerEndpoint = '';

        if (productType === 'OR') {
            headerPostData.Tickets.push({
                "RecId": vm.lastClickedDataItemRecord.RecId,
                "ChangeDate": vm.lastClickedDataItemRecord.ChangeDate,
                "Template": vm.lastClickedDataItemRecord.Template,
                "TableName": vm.lastClickedDataItemRecord.TableName,
                "Event": vm.lastClickedDataItemRecord.Event,
                "UserName": vm.lastClickedDataItemRecord.User,
                "Responsibility": vm.lastClickedDataItemRecord.Responsibility,
                "Application": vm.lastClickedDataItemRecord.Application
            });

            headerEndpoint = 'api/audittrail/or/tickets';
        }
        else if (productType === 'AX7') {
            headerPostData.Tickets.push({
                "RecId": vm.lastClickedDataItemRecord.RecId,
                "ObjRecId": vm.lastClickedDataItemRecord.ObjRecId,
                "ModifiedOn": vm.lastClickedDataItemRecord.ModifiedOn,
                "TableName": vm.lastClickedDataItemRecord.TableName,
                "Event": vm.lastClickedDataItemRecord.Event,
                "Description": vm.lastClickedDataItemRecord.Description,
                "ModifiedBy": vm.lastClickedDataItemRecord.ModifiedBy
            });

            headerEndpoint = 'api/audittrail/ax7/tickets';
        }
        else if (productType === 'SAP') {
            headerPostData.Tickets.push({
                "ChangeNumber": vm.lastClickedDataItemRecord.ChangeNumber,
                "Template": vm.lastClickedDataItemRecord.Template,
                "ChangeDate": vm.lastClickedDataItemRecord.ChangeDate,
                "TableName": vm.lastClickedDataItemRecord.TableName,
                "Event": vm.lastClickedDataItemRecord.Event,
                "UserName": vm.lastClickedDataItemRecord.User
            });

            headerEndpoint = 'api/audittrail/sap/tickets';
        }

        try {
            await $http.post(apiUrl + headerEndpoint, headerPostData);
        } catch (response) {
            helperService.showErrorMessage(response.data);
            vm.actionInProgress = false;
        }
    }

    async function unLinkRecord() {
        vm.actionInProgress = new createSpinner();

        try {
            if (vm.lastClickedDataItemRecord.auditLogTicket) {
                const putData = {
                    "AuditId": vm.lastClickedDataItemRecord.AuditId,
                    "UserId": vm.lastClickedDataItemRecord.UserId,
                    "ObjectName": vm.lastClickedDataItemRecord.ObjectName
                }

                await $http.put(`${apiUrl}api/core/auditlogs/disassociateticket`, putData);
            } else {
                await $http.delete(apiUrl + "api/audittrail/tickets/" + vm.lastClickedDataItemRecord.AtHeaderTicketId);
            }

            await helperService.successfulSaveButton(vm.actionInProgress);
            $uibModalInstance.close();

        } catch (response) {
            helperService.showErrorMessage(response.data);
            vm.actionInProgress.loadingValue = false;
        }
    }

    function dismiss() {
        $uibModalInstance.dismiss();
    }
}